import React from 'react';
import TabHeader from '../../../../components/TabHeader';
import { StyledPage } from '../../../../components/StyledPage';
import { EditBody } from '../../../../components/EditBody';
import EditCreateForm from '../../EditCreateForm';

const GeneralSettings = props => {
  const {id, onUpdateSuccess} = props;
  const encodedID = encodeURIComponent(id);
  const cancelUrl = `/universal_consent_solutions/${encodedID}`;
  return (
    <StyledPage>
      <TabHeader
        title="Edit Mobile Consent Solution"
        subTitle="Fill in details about your mobile consent solution"
      />
      <EditBody basePath="/universal_consent_solutions" resource="universal_consent_solutions" id={id} actions={null}>
        <EditCreateForm {...props} cancelUrl={cancelUrl} onUpdateSuccess={onUpdateSuccess}/>
      </EditBody>
    </StyledPage>
  )};

export default GeneralSettings;
